export default {
	props:{
		phoneCc:{type:String, default:''},
		phoneCcOptions:{type:Array, default(){ return [];} },
		phoneCcName:{type:String, default:'client[phone_cc]'},
		phoneCcLabel:{type:String, default:''},

		phone:{type:String, default:''},
		phoneName:{type:String, default:'client[phone]'},
		phoneLabel:{type:String, default:''},

		floatingLabel:{type:Boolean, default:false},
		cssClass:{type:String, default:'v1'},
		errors:{type:Object, default(){ return {};} },
	},
	data(){
		return {
			innerValue:{phoneCc:'', phone:''},
		}
	},
	watch: {
		phoneCc:{
			immediate: true,
			handler(val){
				this.$set(this.innerValue, 'phoneCc', val);
			},
		},
		phone:{
			immediate: true,
			handler(val){
				this.$set(this.innerValue, 'phone', val);
			},
		},
		"innerValue.phoneCc":{
			immediate: true,
			handler(val){
				this.$emit('update:phoneCc', val);
			},
		},
		"innerValue.phone":{
			immediate: true,
			handler(val){
				this.$emit('update:phone', val);
			},
		},
	},
	computed:{
		cp_phoneCcLabel(){
			return this.phoneCcLabel ? this.phoneCcLabel : this.$t('client.phoneCode');
		},
		cp_phoneLabel(){
			return this.phoneLabel ? this.phoneLabel : this.$t('client.phone');
		}
	},
	methods: {
		onChangePhoneCcOption(selectedOption){
			if(selectedOption && (!this.innerValue.phone || !this.innerValue.phone.startsWith(selectedOption.pc))){
				this.$set(this.innerValue, 'phone', selectedOption.pc);
			}
			this.$refs.clientPhone.focus();
		},
	},
	template: `
<div class="styled-input-phone">
	<qit-input-select
      :name="phoneCcName"
			:class="cssClass"
      :label="cp_phoneCcLabel"
      :floating-label="floatingLabel"
			v-model="innerValue.phoneCc"
			:error-msg="errors.phoneCc"
      :options="phoneCcOptions"
      @change-option="onChangePhoneCcOption"
  ></qit-input-select>
	<qit-input-text
      ref="clientPhone"
      type="tel"
      :name="phoneName"
      :class="cssClass"
			:label="cp_phoneLabel"
      :floating-label="floatingLabel"
			 v-model="innerValue.phone"
      :error-msg="errors.phone"
	></qit-input-text>
</div>
`,
}



